<template>
	<div>
		<!-- 子路由出口：需求详情 / 邀请列表等子页面 -->
		<router-view v-if="$route.path.includes('demanDatails') || $route.path.includes('demanYaoqing') || $route.path.includes('Addemand')"></router-view>
		<div v-else>
			<el-carousel trigger="click">
				<el-carousel-item v-for="item in bannerlist" :key="item">
				   <img :src="item.image" alt="" srcset="" class="bannerlist" @click="downloadFile(item.file)"/>
				</el-carousel-item>
			</el-carousel>
			<div class="sobox">
				<div class="soso">
				   <div class="soinput">
					   <i class="el-icon-search"></i>
					  <input type="text" placeholder="请输入您要搜索的内容" v-model="keyword"> 
				   </div>
				   <button @click="sousuo">搜索</button>
				</div>
			</div>
			<div class="demanNav">
				<ul>
					<li @click="qiehuan(1)" :class="{'canshu':navnumber==1}">
						<img src="@/assets/nav11.png" alt="" srcset="" v-if="navnumber==1"/>
						<img src="@/assets/nav1.png" alt="" srcset=""  v-else/>
						<div class="demanNav1">
							<img src="@/assets/nav1_1.png" alt="" srcset="" />
							<div>
								<span>{{datails.pass_count}}</span>
								<p>报价中</p>
							</div>
						</div>
					</li>
					<li  @click="qiehuan(0)" :class="{'canshu':navnumber==0}">
						<img src="@/assets/nav21.png" alt="" srcset=""  v-if="navnumber==0"/>
						<img src="@/assets/nav2.png" alt="" srcset=""  v-else/>
						<div class="demanNav1">
							<img src="@/assets/nav2_1.png" alt="" srcset="" />
							<div>
								<span>{{datails.audit_count}}</span>
								<p>审核中</p>
							</div>
						</div>
					</li>
					<li  @click="qiehuan(2)" :class="{'canshu':navnumber==2}">
						<img src="@/assets/nav31.png" alt="" srcset=""  v-if="navnumber==2"/>
						<img src="@/assets/nav3.png" alt="" srcset=""  v-else/>
						<div class="demanNav1">
							<img src="@/assets/nav3_1.png" alt="" srcset="" />
							<div>
								<span>{{datails.end_count}}</span>
								<p>已结束</p>
							</div>
						</div>
					</li>
					<li  @click="qiehuan(-1)" :class="{'canshu':navnumber==-1}">
						<img src="@/assets/nav41.png" alt="" srcset=""  v-if="navnumber==-1"/>
						<img src="@/assets/nav4.png" alt="" srcset=""  v-else/>
						<div class="demanNav1">
							<img src="@/assets/nav4_1.png" alt="" srcset="" />
							<div>
								<span>{{datails.reject_count}}</span>
								<p>已驳回</p>
							</div>
						</div>
					</li>
					<li  @click="qiehuan(5)" :class="{'canshu':navnumber==5}">
						<img src="@/assets/nav51.png" alt="" srcset=""  v-if="navnumber==5"/>
						<img src="@/assets/nav5.png" alt="" srcset=""  v-else/>
						<div class="demanNav1">
							<img src="@/assets/nav5_1.png" alt="" srcset="" />
							<div>
								<span>{{datails.total_count}}</span>
								<p>全部需求</p>
							</div>
						</div>
					</li>
				</ul>
			</div>
			<demandList :list="list"></demandList>
			<div class="fenye" v-if="total>9">
			   <el-pagination
				 background
				 @current-change="handleCurrentChange"
				 :current-page.sync="currentPage1"
				 :page-size="9"
				 :page-count="pagecount"
				 layout="total, prev, pager, next ,jumper"
				 :total="total">
			   </el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
	import { DemandIndex,banner} from '@/api/api'
	
	import demandList from '@/common/demandList.vue';
	export default {
	  name: 'HelloWorld',
	  components:{
		demandList  
	  },
	  data() {
	    return {
			  currentPage1:1,
			  navnumber:5,
			  keyword:"",
			  page:1,
			  status:"",
			  list:[],
			  total:0,
			  pagecount:0,
			  datails:{},
			  bannerlist:""
	    }
	  },
	  created() {
	  this.getDemandIndex()
		this.getbanner()
		this.userinfo()
		// 监听来自发布页的刷新事件
		this.$root.$on('refreshDemandIndex', this.getDemandIndex)
	  },
	  beforeDestroy() {
		// 组件销毁前移除事件监听，避免内存泄漏
		this.$root.$off('refreshDemandIndex', this.getDemandIndex)
	  },
	  computed: {
		...mapState({
			user: (state) => state.userInfo || {}
		})
	  },
	  watch: {
	    // 从子页（详情/邀请）返回时刷新列表
	    '$route'(to) {
	        this.getDemandIndex()
	    }
	  },
	  methods: {
		  downloadFile(url) {
			if (!url) return;
			const link = document.createElement("a");
			link.href = url;
			link.target = "_blank";
			link.download = "";
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		userinfo(){
		  	return this.$store.dispatch('fetchPersonal').then(() => {
		  		const u = this.user
		  		if (u && u.review_status == 1) {
		  			this.value = true
		  		} else {
		  			this.value = false
		  		}
		  	})
		},
		getbanner(){
			banner({}).then(res=>{
				this.bannerlist=res.data.data
				this.bannerlist.forEach(item=>{
					if(item.file){
						item.type=this.getFileType(item.file)
					}
				})
			})
		},
		getFileType(url) {
		  const extension = url.split('.').pop().toLowerCase();
		  const typeMap = {
			'jpg': 'image',
			'jpeg': 'image',
			'png': 'image',
			'gif': 'image',
			'zip': 'zip',
			'rar': 'zip',
			'pdf': 'pdf'  ,// 根据实际需求可调整
			
		  };
		  return typeMap[extension] || 'unknown';
		},
		
		handleCurrentChange(e){
			this.page=e
			this.getDemandIndex()
		},
		getDemandIndex(){
			DemandIndex({
				status:this.status,
				keyword:this.keyword,
				page:this.page,
				limit:"9"
			}).then(res=>{
				const data = (res && res.data && res.data.data) || {}
				this.total = Number(data.total) || 0
				this.datails = data || {}
				this.pagecount = Number(data.pass_count) || 0
				this.currentPage1 = Number(data.current_page) || 1
				this.list = Array.isArray(data.data) ? data.data : []
			})
		},
		sousuo(){
			this.page=1
			this.getDemandIndex()
		},
		qiehuan(type){
			this.page=1
			if(type !=5){
				this.navnumber=type
				this.status=type
			}else{
				this.navnumber=type
				this.status=''
			}
			this.getDemandIndex()
		}
	  },
	}
</script>

<style scoped>
	.bannerlist{
		width:100%;
		min-height:100%;
	}
	.sobox{
		width:100%;
		display:flex;
		justify-content:center;
		align-items:center;
		padding:24px 0px;
	}
	.soso{
		width:792px;
		height:52px;
		background: #FFFFFF;
		border-radius: 12px;
		border: 1px solid #1E3A8A;
		padding:10px 12px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items:center;
	}
	.soso button{
		width: 60px;
		height: 32px;
		background: #1E3A8A;
		border-radius: 8px 8px 8px 8px;
		font-weight: 500;
		font-size: 14px;
		color: rgba(255,255,255,0.9);
	    border: none;
	}
	.soinput input{
		width:670px;
		border:none;
		outline:none;
		font-weight: 400;
		font-size: 14px;
	}
	.demanNav{
		width:1200px;
		margin: 0 auto;
	}
	.demanNav ul{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.demanNav li{
		width:220px;
		height:80px;
		position:relative;
		border-radius: 12px 12px 12px 12px;
		cursor:pointer;
	} 
	.canshu{
		box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.2);
	}
	.demanNav li>img{
		width:100%;
		height:100%;
	}
	.demanNav1{
		width:100%;
		height:100%;
		position:absolute;
		top: 0;
		left: 0;
		padding:18px 20px;
		box-sizing: border-box;
		display:flex;
		align-items: center;
	}
	.demanNav1 img{
		width:42px;
		height:42px;
		margin-right:10px;
	}
	.demanNav1 span{
		font-weight: 800;
		font-size: 19px;
		color: #FFFFFF;
	}
	.demanNav1 p{
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
	}
	.fenye{
		width:100%;
		display:flex;
		align-items: center;
		justify-content: center;
		padding-bottom:20px;
	}
</style>